import { PageContainer, ProTable, type ProColumns } from '@ant-design/pro-components'
import { createFileRoute } from '@tanstack/react-router'
import { Typography } from 'antd'
import { z } from 'zod'
import { systemContractVariables } from '@super-mega/server/contracts/contract'
import { CONTRACT_TEMPLATE_TYPES } from '@/features/contract/index.ts'

export const Route = createFileRoute('/_authenticated/contracts/variables')({
  component: ContractVariablesPage,
  head: () => ({ meta: [{ title: '合同动态字段 · Super Mega' }] }),
  validateSearch: z.object({
    current: z.coerce.number().int().min(1).catch(1),
    pageSize: z.coerce.number().int().min(1).max(100).catch(20)
  })
})

type VariableRow = (typeof systemContractVariables)[number]

const columns: ProColumns<VariableRow>[] = [
  { title: '字段名称', dataIndex: 'label' },
  {
    title: '本系统占位符',
    dataIndex: 'key',
    render: (_, row) => <Typography.Text code copyable>{`{{${row.key}}}`}</Typography.Text>
  },
  {
    title: '兼容旧占位符 / 别名',
    dataIndex: 'aliases',
    render: (_, row) => (
      <div className="flex flex-col gap-1">
        {row.aliases.length === 0
          ? '—'
          : row.aliases.map((key) => <Typography.Text key={key} code copyable>{`{{${key}}}`}</Typography.Text>)}
      </div>
    )
  },
  { title: '取值说明', dataIndex: 'description' },
  {
    title: '适用模板',
    dataIndex: 'supportedTypes',
    renderText: (types: readonly string[]) =>
      Object.entries(CONTRACT_TEMPLATE_TYPES)
        .filter(([type]) => types.includes(type))
        .map(([, value]) => value.label)
        .join('、')
  }
]

function ContractVariablesPage() {
  return (
    <PageContainer
      breadcrumbRender={false}
      content="输入 @ 插入本系统字段；搜索旧字段名也会推荐对应的新字段。已有模板中的旧占位符继续兼容。orderNo 是业务订单编号，order_id 保留数字主键语义。旧甲方电话 {{setting.phone}} 暂无档案来源，生成时需人工补填。"
      title="动态字段目录"
    >
      <ProTable<VariableRow>
        columns={columns}
        columnsState={{ persistenceKey: 'contracts-variables:catalog', persistenceType: 'localStorage' }}
        dataSource={[...systemContractVariables]}
        rowKey="key"
        scroll={{ x: '70rem' }}
        search={false}
        pagination={false}
        options={false}
        toolBarRender={false}
        size="small"
      />
    </PageContainer>
  )
}
